import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'

export const FinalizePrescriptionErrorToast: FC = () => {
  const { t } = useTranslation(['Dialogs'])

  return (
    <KibTopLevelAlert
      heading={t('Dialogs:SWAP_PRODUCT_DIALOG.SWAP_ERROR_MESSAGE')}
      severity="error"
    />
  )
}
